import LazyWidgetController from "./lazy_widget_controller"

// Stimulus controller wrapping Pickr for the .color-picker-field input.
//
// Lifecycle (lazy import + Turbo-cache-safe teardown) is handled by
// LazyWidgetController; this subclass supplies load()/build()/destroy().
//
// Behaviour (unchanged from the legacy `$('.color-picker-field').each(...)`):
//   - useAsButton, the input element itself is the trigger (el: input)
//   - default colour comes from the input's current value
//   - on('init') / on('save') set the input value and the background of the
//     adjacent .input-group-text inside the surrounding .input-group
//
// Usage in views (rendered by AppFormBuilder app_color_picker):
//   <div class="input-group">
//     <input type="text" data-controller="color-picker" class="color-picker-field">
//     <span class="input-group-text"></span>
//   </div>
//
export default class extends LazyWidgetController {
  async load() {
    return (await import("@simonwep/pickr")).default
  }

  build(Pickr) {
    const inputElement = this.element

    // Vanilla DOM lookup for the swatch preview (was element.closest(...).find(...)).
    const swatch = inputElement.closest('.input-group')?.querySelector('.input-group-text')

    const pickr = Pickr.create({
      useAsButton: true,
      default: (inputElement.value.length > 0 ? inputElement.value : ''),
      defaultRepresentation: 'HEX',
      el: inputElement,
      theme: 'nano',
      swatches: null,
      components: {
        preview: true,
        opacity: false,
        hue: true,
        interaction: {
          hex: true,
          rgba: true,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: true,
          clear: true,
          save: true
        }
      }
    })

    pickr.on('init', p => {
      inputElement.value = p.getSelectedColor().toHEXA().toString(0)
      if (swatch) swatch.style.backgroundColor = inputElement.value
    }).on('save', color => {
      inputElement.value = color.toHEXA().toString(0)
      if (swatch) swatch.style.backgroundColor = inputElement.value
      pickr.hide()
    })

    return pickr
  }

  destroy(pickr) {
    pickr.hide()
    pickr.destroyAndRemove()
  }
}
